import { getOptionsFromEnum } from '../../../../../../utils/getOptionsFromEnum';

import { Gender } from '../../../../../../models/Gender';
import { Prefix } from '../../../../../../models/Prefix';

export const genderOptions = getOptionsFromEnum(Gender, 'gender');
export const prefixOptions = getOptionsFromEnum(Prefix, 'prefix');
